<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('分红池.分红池')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
<!--					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">-->
<!--						<span class="text-32 text-white">{{$t('分红池.持有者')}}</span>-->
<!--					</div>-->
					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('分红池.分红池')}}</span>
					</div>
					<div @click="setQueryInfo(3)" :class="[queryInfo.type == 3 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('分红池.FOMO')}}</span>
					</div>
					<div @click="setQueryInfo(4)" :class="[queryInfo.type == 4 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('分红池.保险')}}</span>
					</div>
				</div>
				<!-- 持有者 -->
				<div v-if="queryInfo.type == 1" class="">
					<div class=" rounded-20 p-30" style="background-color: #280A00;">
						<div class="flex items-center justify-between">
							<span class="text-28 text-white">{{$t('分红池.LP持有者分红')}}</span>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#EB470C; background-color: #EB470C20;">
								<span class="text-20" style="color: #EB470C;">25%</span>
							</div>
						</div>
						<div class="mt-30 flex items-center justify-center">
							<span class="text-24 text-#999">{{$t('分红池.分红奖池总额')}}</span>
						</div>
						<div class="mt-30 flex items-center justify-center">
							<span class="text-60 text-white font-bold">$125,000</span>
						</div>
						<div class="mt-30 flex items-center justify-center rounded-20 h-130" style="background-color: #441201;">
							<div class="text-center">
								<div>
									<span class="text-20 text-#ccc">{{$t('分红池.我的LP')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-44 text-primary font-bold">$10,000</span>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-30 rounded-20 bg-white/10 p-30">
						<div class="mb-30">
							<span class="text-28 text-white">{{$t('分红池.持有者列表')}}</span>
						</div>
						<div v-for="(item, index) in 10" :key="index" class="bg-white/10 p-20 rounded-20 flex items-center mb-20">
							<div v-if="index == 0" class="w-88 h-88 rounded-20 flex items-center justify-center"
							 style="background-image: linear-gradient(to bottom, #FF9A41, #FF8316);">
							 <span class="text-white text-36">1</span>
							 </div>
							 <div v-else-if="index == 1" class="w-88 h-88 rounded-20 flex items-center justify-center"
							  style="background-image: linear-gradient(to bottom, #CACED5, #8D929C);">
							  <span class="text-white text-36">2</span>
							  </div>
							  <div v-else-if="index == 2" class="w-88 h-88 rounded-20 flex items-center justify-center"
							   style="background-image: linear-gradient(to bottom, #D85E58, #D85E58);">
							   <span class="text-white text-36">3</span>
							   </div>
							   <div v-else class="w-88 h-88 rounded-20 flex items-center justify-center"
							    style="background-image: linear-gradient(to bottom, #4B4646, #4B4646);">
							    <span class="text-white text-36">{{index + 1}}</span>
							    </div>
								<div class="ml-20 flex-1">
									<div class="">
										<span class="text-28 text-white">0x8b3e...7c2d</span>
									</div>
									<div class="mt-10">
										<span class="text-24 font-bold" style="color: #A81CF3;">LP $10,000</span>
									</div>
								</div>
								<div class="">
									<span class="text-40 text-primary font-bold">8.5%</span>
								</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("分红池.分红规则")}}</span>
						</div>
						<div class="mt-20 bg-white/10 rounded-20 p-30">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.盈利的25%自动分配给所有LP持有者")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.按照LP持有比例进行分红")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.每周自动发放到钱包地址")}}</span>
							</div>
						</div>
						<div class="mt-30 rounded-20 flex items-center justify-between h-90 px-30" style="background-color: #441201;">
							<span class="text-28 text-#ccc font-bold">{{$t("分红池.下次分红时间")}}</span>
							<span class="text-32 text-primary font-bold">202-11-10</span>
						</div>
					</div>
				</div>
				<!-- 锁仓 -->
				<div v-else-if="queryInfo.type == 2" class="">
					<div class="">
						<span class="text-40 text-white font-bold">分红池</span>
					</div>
					<div class="mt-20 mb-30">
<!--						<span class="text-24 text-#999">{{$t("分红池.查看所有ROON锁仓记录")}}</span>-->
					</div>
					<div v-for="(item, index) in dividend_pool" :key="index" class="bg-white/10 rounded-20 p-30 mb-20">
						<div class="flex items-center justify-between">
							<div class="flex-1 ml-20">
								<div class="flex items-center justify-between">
									<span class="text-36 text-white">{{item.roon}} ROON</span>
<!--									<div v-if="index == 0" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"-->
<!--										style="border-color:#F09A0D; background-color: #F09A0D20;">-->
<!--										<span class="text-20" style="color: #F09A0D;">{{$t("分红池.锁定中")}}</span>-->
<!--									</div>-->
<!--									<div v-else class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"-->
<!--										style="border-color:#1BB853; background-color: #1BB85320;">-->
<!--										<span class="text-20" style="color: #1BB853;">{{$t("分红池.已完成")}}</span>-->
<!--									</div>-->
								</div>
<!--								<div class="mt-10">-->
<!--									<span class="text-24 text-#999">{{$t("分红池.开始日期")}}  2023-12-01</span>-->
<!--								</div>-->
							</div>
						</div>
						<div class="mt-30 bg-white/10 rounded-20 flex items-center py-30 px-40">
							<div class="flex-1">
								<div>
									<span class="text-20 text-#999">{{$t("分红池.锁仓时长")}}</span>
								</div>
								<div class="mt-10">
									<span class="text-36 font-bold" style="color: #9646FF;">{{item.days}}{{$t("天")}}</span>
								</div>
							</div>
							<div class="flex-1">
								<div>
									<span class="text-20 text-#999">分红比例</span>
								</div>
								<div class="mt-10">
									<span class="text-36 font-bold text-primary">{{item.rato}}%</span>
								</div>
							</div>
						</div>
						<div class="mt-30 flex items-center justify-between">
							<span class="text-24 text-#999">池累计</span>
							<span class="text-24 text-white">{{item.pool_number}}USDR</span>
						</div>
                        <div class="mt-30 h-100 rounded-full flex items-center justify-center cursor-pointer" style="background-color: #02210D;" @click="participate(item)">
                            <span class="text-32 font-bold text-success">参与</span>
                        </div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("分红池.锁仓说明")}}</span>
						</div>
						<div class="mt-20 bg-white/10 rounded-20 p-30">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.锁走期为1年，期间无法提取")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.到期后获得本金+固定收益")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.收益来自盈利分配池")}}</span>
							</div>
						</div>
					</div>


                    <!-- 我的锁仓记录列表 -->
                    <div class="mt-20 rounded-20 bg-white/10 p-30" v-if="lp_dividend_user.length > 0" >
                        <div class="mb-20">
                            <span class="text-28 text-white">我的锁仓记录</span>
                        </div>
                        <!-- 卡片样式参考现有列表（116 行附近） -->
                        <div v-for="(rec, idx) in lp_dividend_user" :key="rec.id || idx" class="bg-white/10 p-20 rounded-20 mb-20">
                            <div class="flex items-center">
                                <img class="w-88 h-88" src="@/assets/images/pages/dividend-pool/img_ksrq.png" alt="" />
                                <div class="flex-1 ml-20">
                                    <div class="flex items-center justify-between">
                                        <span class="text-36 text-white">{{ rec.roon_amount }} ROON</span>
                                        <div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
                                            :style="statusBadgeStyle(rec.status)">
                                            <span class="text-20" :style="statusBadgeTextStyle(rec.status)">{{ rec.status_name }}</span>
                                        </div>
                                    </div>
                                    <div class="mt-10">
                                        <span class="text-24 text-#999">参与时间</span>
                                        <span class="ml-10 text-24 text-white">{{ formatDateTime(rec.start_date) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-20 bg-white/10 rounded-20 py-30 px-40">
                                <div class="flex items-center justify-between">
                                    <span class="text-20 text-#999">累计分红</span>
                                    <span class="text-20 text-#999">剩余天数</span>
                                </div>
                                <div class="mt-10 flex items-center justify-between">
                                    <span class="text-28 font-bold text-primary">{{ rec.dividend }} USDR</span>
                                    <span class="text-28 text-white">{{ rec.surplus_day }} 天</span>
                                </div>
                            </div>
                            <!-- 操作按钮同一行布局 -->
                            <div class="mt-20 flex items-center" v-if="Math.floor(Date.now() / 1000) >= rec.end_time && rec.status === 0">
                                <div @click="handleWithdraw(rec)" class="flex-1 h-70 rounded-12 flex items-center justify-center border border-solid mr-12" style="border-color:#EB470C; background-color: #EB470C20;">
                                    <span class="text-26" style="color: #EB470C;">撤回</span>
                                </div>
                                <div @click="handleReinvest(rec)" class="flex-1 h-70 rounded-12 flex items-center justify-center border border-solid" style="border-color:#1BB853; background-color: #1BB85320;">
                                    <span class="text-26" style="color: #1BB853;">复投</span>
                                </div>
                            </div>
                        </div>
                    </div>

				</div>
				<!-- FOMO -->
				<div v-else-if="queryInfo.type == 3" class="">
					<div class="dividend-pool-item1-bg-image p-30">
						<div class="flex items-center justify-between">
							<span class="text-28 text-white">{{$t('分红池.FOMO池')}}</span>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#F419DE; background-color: #F419DE20;">
								<span class="text-20" style="color: #F419DE;">48h</span>
							</div>
						</div>
						<div class="mt-30 flex items-center justify-center">
							<span class="text-24 text-#999">{{$t('分红池.奖池总额')}}</span>
						</div>
						<div class="mt-30 flex items-center justify-center">
							<span class="text-60 text-white font-bold">{{fomo_pool}}</span>
						</div>
						<div class="mt-30 rounded-20 h-130 px-30 py-20" style="background-color: #40042E;">
							<div class=" flex items-center justify-between">
								<div>
									<span class="text-26 text-#ccc">{{$t('分红池.倒计时')}}</span>
								</div>
								<div class="">
									<van-count-down style="color: #fff; font-size: 30rem;" :time="last_time" />
								</div>
							</div>
							<div class="mt-10 flex items-center">
								<span class="text-20 text-#ccc">{{$t('分红池.最后参与')}}:</span>
								<span class="text-20 text-#ccc">{{last_address}}</span>
							</div>
						</div>
					</div>
					<div class="mt-30 rounded-20 bg-white/10 p-30">
						<div class="mb-30">
							<span class="text-28 text-white">{{$t('分红池.排行榜（前20名）')}}</span>
						</div>
						<div v-for="(item, index) in end_tops" :key="index" class="bg-white/10 p-20 rounded-20 flex items-center mb-20">
							<div v-if="index == 0" class="w-88 h-88 rounded-20 flex items-center justify-center"
							 style="background-image: linear-gradient(to bottom, #FF9A41, #FF8316);">
							 <span class="text-white text-36">1</span>
							 </div>
							 <div v-else-if="index == 1" class="w-88 h-88 rounded-20 flex items-center justify-center"
							  style="background-image: linear-gradient(to bottom, #CACED5, #8D929C);">
							  <span class="text-white text-36">2</span>
							  </div>
							  <div v-else-if="index == 2" class="w-88 h-88 rounded-20 flex items-center justify-center"
							   style="background-image: linear-gradient(to bottom, #D85E58, #D85E58);">
							   <span class="text-white text-36">3</span>
							   </div>
							   <div v-else class="w-88 h-88 rounded-20 flex items-center justify-center"
							    style="background-image: linear-gradient(to bottom, #4B4646, #4B4646);">
							    <span class="text-white text-36">{{index + 1}}</span>
							    </div>
								<div class="ml-20 flex-1">
									<div class="">
										<span class="text-28 text-white">{{item.user.show_address}}</span>
									</div>
									<div class="mt-10">
										<span class="text-24 font-bold" style="color: #A81CF3;">{{item.start_date}}</span>
									</div>
								</div>
								<div class="">
									<span class="text-24 text-primary font-bold">LP {{item.lp_token}}</span>
								</div>
						</div>
					</div>
					<div class="mt-30 rounded-20 bg-white/10 p-30">
						<div class="mb-30">
							<span class="text-28 text-white">{{$t('分红池.奖励分配规则')}}</span>
						</div>
						<div class="mt-30 h-80 flex items-center justify-between px-30">
							<span class="text-24 text-#ccc">{{$t('分红池.排名')}}</span>
							<span class="text-24 text-#ccc">{{$t('分红池.奖励')}}</span>
						</div>
						<div class="rounded-20 overflow-hidden">
							<div class="h-80 flex items-center justify-between px-30" style="background-color: #333333;">
								<span class="text-24 text-#ccc">{{$t('分红池.第')}}1{{$t('分红池.名')}}</span>
								<span class="text-24 text-#ccc">20%</span>
							</div>
							<div class="h-80 flex items-center justify-between px-30" style="background-color: #2C2C2C;">
								<span class="text-24 text-#ccc">{{$t('分红池.第')}}2{{$t('分红池.名')}}</span>
								<span class="text-24 text-#ccc">10%</span>
							</div>
							<div class="h-80 flex items-center justify-between px-30" style="background-color: #333333;">
								<span class="text-24 text-#ccc">{{$t('分红池.第')}}3{{$t('分红池.名')}}</span>
								<span class="text-24 text-#ccc">5%</span>
							</div>
							<div class="h-80 flex items-center justify-between px-30" style="background-color: #2C2C2C;">
								<span class="text-24 text-#ccc">{{$t('分红池.第')}}4-10{{$t('分红池.名')}}</span>
								<span class="text-24 text-#ccc">{{$t('分红池.平分')}}35%</span>
							</div>
							<div class="h-80 flex items-center justify-between px-30" style="background-color: #333333;">
								<span class="text-24 text-#ccc">{{$t('分红池.第')}}11-20{{$t('分红池.名')}}</span>
								<span class="text-24 text-#ccc">{{$t('分红池.平分')}}30%</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("分红池.FOMO规则")}}</span>
						</div>
						<div class="mt-20 bg-white/10 rounded-20 p-30">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.48小时内无新增参与则触发分配")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.保险池每10天转入10%到FOMO池")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.前20名按排名获得奖励")}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 保险 -->
				<div v-else-if="queryInfo.type == 4" class="">
					<div class="dividend-pool-item2-bg-image p-30">
						<div class="flex items-center justify-between">
							<span class="text-28 text-white">{{$t('分红池.保险池')}}</span>
<!--							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid" style="border-color:#43AFFF; background-color: #43AFFF20;">-->
<!--								<span class="text-20" style="color: #43AFFF;">48h</span>-->
<!--							</div>-->
						</div>
						<div class="mt-30 flex items-center justify-center">
							<span class="text-24 text-#999">{{$t('分红池.保险池总额')}}</span>
						</div>
						<div class="mt-30 flex items-center justify-center">
							<span class="text-60 text-white font-bold">{{insure_pool}}</span>
						</div>
						<div class="mt-30 rounded-20 h-130 px-30 py-20" style="background-color: #01253F;">
							<div class=" flex items-center justify-between">
								<div>
									<span class="text-26 text-#ccc">{{$t('分红池.待转入FOMO池')}}</span>
								</div>
								<div>
									<span class="text-20 text-#ccc">{{$t('分红池.下次转入')}}</span>
								</div>
							</div>
							<div class="mt-10 flex items-center justify-between">
                                <div class="">
                                    <van-count-down
                                        style="color: #fff; font-size: 40rem;"
                                        :time="to_fomo_djs" />
                                </div>

								<span class="text-36 font-bold text-white">{{to_fomo_djs_date}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("分红池.资金流向")}}</span>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #122139;">
							<div class="flex items-center">
								<div class="w-60 h-60 flex items-center justify-center rounded-12" style="background-color: #36A0FA;">
									<span class="text-50 text-white font-bold">1</span>
								</div>
								<div class="flex-1 ml-20 flex items-center justify-between">
									<span class="text-28 text-white">{{$t('分红池.保险池')}}</span>
									<span class="text-40 font-bold text-white" style="color: #42AFFF;">25%</span>
								</div>
							</div>
							<div class="mt-20">
								<span class="text-24 text-#ccc">{{$t('分红池.盈利的25%进入保险池')}}</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #3E032D;">
							<div class="flex items-center">
								<div class="w-60 h-60 flex items-center justify-center rounded-12" style="background-color: #FA36C0;">
									<span class="text-50 text-white font-bold">1</span>
								</div>
								<div class="flex-1 ml-20 flex items-center justify-between">
									<span class="text-28 text-white">{{$t('分红池.FOMO池')}}</span>
									<span class="text-40 font-bold text-white" style="color: #FA36C0;">{{to_fomo_day}}{{$t('分红池.天')}}</span>
								</div>
							</div>
							<div class="mt-20">
								<span class="text-24 text-#ccc">{{$t('分红池.每10天转入保险池的10%')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("分红池.保险池作用")}}</span>
						</div>
						<div class="mt-20 bg-white/10 rounded-20 p-30">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.保障系统稳定运行")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.定期为FOMO池注入资金")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("分红池.应对市场波动风险")}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
             <van-popup v-model="againPopup" position="center" round>
                 <div class="w-690">
                     <div class="flex items-center justify-center relative h-200">
                         <img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png" alt="" />
                     </div>
                     <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
                         <div class="flex items-center justify-center mt-20">
                             <span class="text-36 text-white">确定复投 LP</span>
                         </div>

                         <div class="mt-40 flex items-center justify-center">
                             <div @click="againPopup = false"
                                  class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
                                 <span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
                             </div>
                             <div @click="again"
                                  class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
                                 <span class="text-32 text-white">确定复投</span>
                             </div>
                         </div>
                     </div>
                 </div>
             </van-popup>

             <van-popup v-model="withdrawPopup" position="center" round>
                 <div class="w-690">
                     <div class="flex items-center justify-center relative h-200">
                         <img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png" alt="" />
                     </div>
                     <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
                         <div class="flex items-center justify-center mt-20">
                             <span class="text-36 text-white">确定撤回</span>
                         </div>
                         <div class="flex items-center justify-center mt-20">
                             <span class="text-26 text-#999">您即将撤回并获得以下资产</span>
                         </div>
                         <div class="rounded-18 bg-#1B1B1B  mt-20 mx-20 p-30">
                             <div class="flex items-center justify-between">
                                 <span class="text-24 text-white">本金返还</span>
                                 <span class="text-24 text-white">{{showItem.roon_amount}} ROON</span>
                             </div>

                         </div>
                         <div class="mt-40 flex items-center justify-center">
                             <div @click="withdrawPopup = false"
                                  class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
                                 <span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
                             </div>
                             <div @click="withdraw"
                                  class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
                                 <span class="text-32 text-white">确定撤回</span>
                             </div>
                         </div>
                     </div>
        </div>
     			</van-popup>

            <!-- 不可取消的全局 Loading 遮罩（撤回/链上交易过程中显示） -->
            <van-popup v-model="paying" position="center" round :close-on-click-overlay="false">
                <div class="w-500 p-40 flex items-center justify-center flex-col" style="background-color: rgba(15,15,23,0.95); border-radius: 20rem;">
                    <van-loading type="spinner" color="#fff" size="30rem" />
                    <span class="mt-20 text-28 text-white">加载中...</span>
                </div>
            </van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import DividendPoolAbi from "@/abi/DividendPoolAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
                fomo_pool: 0,
                last_time: 0,
                last_address: 0,
                insure_pool: 0,
                to_fomo_djs: 0,
                to_fomo: "",
                to_fomo_djs_date: "",
                to_fomo_day:10,
                to_fomo_rato:10,
				typeList: [],
                end_tops: [],
				queryInfo: {
					page: 1,
					type: 2
				},
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
                dividend_pool_address: "0x6605A9322Ea977593666A2876ff5B3B8836CE6D4",
				web3Provider: null,
                web3: null,
                list: [],
                dividend_pool: [],
                lp_dividend_user: [],
                showAmountPopup: false,
                againPopup: false,
                withdrawPopup: false,
                showItem: {
                    id: 0,
                    principal: 0,
                    record_id: 0,
                    static: 0,
                },
                // 支付进行中的不可关闭 loading 遮罩
                paying: false,
                canGo: true,
                form: {
                    type: 1,
                    amount: 0,
                    dd_roon: 0,
                    amount_id: 0
                },
                // 是否购买
                isBuy: true,
                numberList: [{
                        id: 1,
                        num: 100
                    },
                    {
                        id: 2,
                        num: 500
                    },
                    {
                        id: 3,
                        num: 1000
                    },
                    {
                        id: 4,
                        num: 2000
                    },
                    {
                        id: 5,
                        num: 5000
                    },

                ],
                // 我的锁仓记录（示例数据，可替换为接口返回）
                myLocks: [
                    {
                        id: 1,
                        amount: 500,
                        time: '2025-12-16 12:36:45',
                        dividend: 12,
                        status: '进行中',
                        daysRemaining: 7
                    }
                ]
            };
        },
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);
			}
			vm.getList();
		},
        methods: {
            async participate(item){
                const vm = this;
                try {
                    if (!vm.web3) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 校验链 ID 是否为 ROON 主网（1492）
                    let chainId;
                    try {
                        const idHex = await (vm.web3Provider?.request ? vm.web3Provider.request({ method: 'eth_chainId' }) : null);
                        chainId = typeof idHex === 'string' ? parseInt(idHex, 16) : await vm.web3.eth.getChainId();
                    } catch (e) {
                        chainId = await vm.web3.eth.getChainId();
                    }
                    if (Number(chainId) !== 1492) {
                        vm.$message.error("请切换到ROON主网");
                        return;
                    }

                    // 校验合约地址
                    const contractAddr = vm.dividend_pool_address;
                    if (!contractAddr || !vm.web3.utils.isAddress(contractAddr)) {
                        vm.$message.error(utils.$t("吐司.合约地址缺失"));
                        return;
                    }

                    // 参数准备：pool_id 与 days 秒数（合约第二参数为秒）
                    const pool_id = item?.id;
                    const daysInt = parseInt(item?.days, 10);
                    if (!Number.isInteger(pool_id)) {
                        vm.$message.error(utils.$t("吐司.操作失败"));
                        return;
                    }
                    if (!Number.isInteger(daysInt) || daysInt <= 0) {
                        vm.$message.error(utils.$t("吐司.操作失败"));
                        return;
                    }
                    // days -> seconds，使用 BN 防止溢出
                    let secondsBN = vm.web3.utils.toBN(daysInt).mul(vm.web3.utils.toBN('86400'));
                    let seconds = secondsBN.toString();

                    // 主币支付金额（ROON 为原生币），无需授权
                    let amountNative = Number(item?.roon);
                    if (!isFinite(amountNative) || amountNative <= 0) {
                        vm.$message.error(utils.$t("吐司.操作失败"));
                        return;
                    }
                    const valueWei = vm.web3.utils.toWei(amountNative.toString(), 'ether');

                    // 获取钱包地址
                    let accounts = [];
                    try {
                        accounts = await vm.web3.eth.requestAccounts();
                    } catch (_) {
                        // 兼容某些环境直接用 provider 请求
                        accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                    }
                    const from = accounts && accounts[0];
                    if (!from) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    const contract = new vm.web3.eth.Contract(DividendPoolAbi, contractAddr);


                    // seconds = "1"
                    // 预估 gas（失败也不阻塞发送）
                    let gas;
                    try {
                        gas = await contract.methods.participate(pool_id, seconds).estimateGas({ from, value: valueWei });
                    } catch (e) {
                        // 打印更详细错误以便定位
                        console.log('estimateGas error:', e?.message, e?.data?.message, e?.data?.originalError?.message);
                        gas = undefined;
                    }

                    //
                    vm.$message.success(utils.$t("吐司.请在钱包确认交易"));
                    await contract.methods.participate(pool_id, seconds).send({ from, gas, value: valueWei });
                    vm.$message.success("操作成功，请稍后刷新查看");

                    // 成功后刷新列表
                    // vm.getList();
                } catch (err) {
                    console.error(err);
                    vm.$message.error(err?.message || utils.$t("吐司.操作失败"));
                }
            },
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
			getList() {
				let vm = this
				getShowAddress()
				ajaxData("/lp/dividend/pool").then(res => {
					console.log(res)
					vm.end_tops = res.data.end_tops;
					vm.last_address = res.data.last_address;
					vm.dividend_pool = res.data.dividend_pool;
					vm.lp_dividend_user = res.data.lp_dividend_user;
					vm.insure_pool = res.data.insure_pool;
					vm.fomo_pool = res.data.fomo_pool;
					vm.to_fomo_rato = res.data.to_fomo_rato;
					vm.to_fomo_day = res.data.to_fomo_day;
					vm.to_fomo = res.data.to_fomo;
					vm.to_fomo_djs = parseInt(res.data.to_fomo_djs) * 1000;
					vm.last_time = parseInt(res.data.last_time) * 1000;
                    console.log(vm.to_fomo_djs)
					vm.to_fomo_djs_date = res.data.to_fomo_djs_date;
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
            refresherpulling() {
                this.triggered = true;
                setTimeout(() => {
                    this.triggered = false;
                }, 200)
                console.log("下拉刷新");
            },
            // 格式化日期时间显示
            formatDateTime(v) {
                try {
                    if (!v) return '';
                    if (typeof v === 'string') return v;
                    const d = new Date(Number(v));
                    const pad = (n) => (n < 10 ? '0' + n : n);
                    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
                } catch (_) {
                    return String(v);
                }
            },
            // 根据状态返回样式类
            statusClass(status) {
                switch (status) {
                    case '进行中':
                        return 'text-#F09A0D';
                    case '已完成':
                        return 'text-#1BB853';
                    case '已复投':
                        return 'text-#42AFFF';
                    default:
                        return 'text-white';
                }
            },
            // 状态徽章容器样式
            statusBadgeStyle(status) {
                switch (status) {
                    case 0:
                        return 'border-color:#F09A0D; background-color:#F09A0D20;';
                    case 1:
                        return 'border-color:#1BB853; background-color:#1BB85320;';
                    case 2:
                        return 'border-color:#42AFFF; background-color:#42AFFF20;';
                    default:
                        return 'border-color:#999; background-color:#99920;';
                }
            },
            // 状态徽章文字样式
            statusBadgeTextStyle(status) {
                switch (status) {
                    case 0:
                        return 'color:#F09A0D;';
                    case 1:
                        return 'color:#1BB853;';
                    case 2:
                        return 'color:#42AFFF;';
                    default:
                        return 'color:#999;';
                }
            },
            // 撤回按钮事件
            handleWithdraw(rec) {
                console.log('撤回记录', rec);
                this.showItem = rec;
                this.withdrawPopup = true;
            },
            async withdraw() {
                const vm = this;
                try {
                    if (!vm.web3) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 先调用后端接口，成功后再继续链上交易
                    vm.paying = true;
                    try {
                        const resp = await ajaxData("/lp/dividend/pool/remove", { id: vm.showItem.id });
                        console.log("/lp/dividend/pool/remove resp", resp);
                    } catch (apiErr) {
                        console.error("/lp/dividend/pool/remove error", apiErr);
                        vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
                        vm.paying = false;
                        return; // 接口异常直接结束，不继续链上操作
                    }

                    // 校验链 ID
                    let chainId;
                    try {
                        const idHex = await (vm.web3Provider?.request ? vm.web3Provider.request({ method: 'eth_chainId' }) : null);
                        chainId = typeof idHex === 'string' ? parseInt(idHex, 16) : await vm.web3.eth.getChainId();
                    } catch (e) {
                        chainId = await vm.web3.eth.getChainId();
                    }
                    if (Number(chainId) !== 1492) {
                        vm.$message.error("请切换到ROON主网");
                        vm.paying = false;
                        return;
                    }

                    const contractAddr = vm.dividend_pool_address;
                    if (!contractAddr || !vm.web3.utils.isAddress(contractAddr)) {
                        vm.$message.error(utils.$t("吐司.合约地址缺失"));
                        vm.paying = false;
                        return;
                    }

                    // 获取钱包地址
                    let accounts = [];
                    try {
                        accounts = await vm.web3.eth.requestAccounts();
                    } catch (_) {
                        accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                    }
                    const from = accounts && accounts[0];
                    if (!from) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        vm.paying = false;
                        return;
                    }

                    const contract = new vm.web3.eth.Contract(DividendPoolAbi, contractAddr);

                    // 预估 gas
                    let gas;
                    try {
                         gas = await contract.methods.withdraw(vm.showItem.record_id).estimateGas({ from });
                    } catch (e) {
                         console.log('estimateGas error:', e);
                    }

                    vm.$message.success(utils.$t("吐司.请在钱包确认交易"));
                    await contract.methods.withdraw(vm.showItem.record_id).send({ from, gas });
                    vm.$message.success("操作成功，请稍后刷新查看");

                    vm.paying = false;
                    vm.withdrawPopup = false;
                    vm.getList(); // 刷新列表

                } catch (err) {
                    console.error(err);
                    vm.$message.error(err?.message || utils.$t("吐司.操作失败"));
                } finally {
                    // 兜底关闭遮罩
                    vm.paying = false;
                }
            },
            again() {
                let vm = this
                ajaxData("/lp/dividend/pool/again",{
                    id:vm.showItem.id
                }).then(res => {
                    console.log(res)
                    vm.$message.success("操作成功")
                    vm.getList()
                    vm.againPopup = false
                })
            },
            // 复投按钮事件
            handleReinvest(rec) {
                console.log('复投记录', rec);
                this.showItem = rec;
                this.againPopup = true;
            }
        },
    };
</script>

<style scoped>
	.dividend-pool-item1-bg-image {
		width: 690rem;
		height: 420rem;
		background-image: url("~@/assets/images/pages/dividend-pool/itemBg1.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}


	.dividend-pool-item2-bg-image {
		width: 690rem;
		height: 420rem;
		background-image: url("~@/assets/images/pages/dividend-pool/itemBg2.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

</style>


